export const FulfillmentType = {
  SINGLE_ITEM_PACKAGE: 'single_item_package',
  MULTI_ITEM_PACKAGE: 'multi_item_package',
  CUSTOM_PACKAGE: 'custom_package',
  PROJECT_BPI: 'project-bpi',
  PROJECT_BPI_PRICE_INCREASE: 'project-bpi-price-increase',
}
